<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import AppNotice from '../../primitives/AppNotice/AppNotice.vue'
import { DESIGN_RUN_NOTICE, designRunNoticeState, designRunReasonKey } from './design-run-notice'
import type { DesignRun } from '@/types/design'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    /** The design's most recent background session, or `null` when it has never run. */
    run?: DesignRun | null
    loading?: boolean
  }>(),
  { run: null, loading: false },
)

const entry = computed(() => {
  const state = designRunNoticeState(props.run, props.loading)
  return state ? DESIGN_RUN_NOTICE[state] : null
})

const message = computed(() =>
  entry.value
    ? t(entry.value.messageKey, { reason: t(designRunReasonKey(props.run?.errorCode ?? null)) })
    : '',
)
</script>

<template>
  <AppNotice v-if="entry" :tone="entry.tone" :message="message" />
</template>
